import { isObjectLike } from 'lodash';
import { CellData } from '../../../../../common/table/TableTypes';
import { parseCellContentString } from '../../../../../common/table/utils/tableCellContentStringUtils';
import { convertFromRaw, EditorState } from 'draft-js';

/**
 * Determines whether the current cell, that contains DraftJS raw content,
 * has the specified inline style applied.
 *
 * NOTE: This util is shared between legacy and new table, so would need to support both data types
 */
export const doesTableCellDataHaveInlineStyles = (cellData: CellData, inlineStyle: string): boolean => {
    if (cellData.textStyle?.includes(inlineStyle)) return true;

    if (!cellData.value) return false;

    const content = cellData.draftContent || parseCellContentString(cellData.value);

    if (!isObjectLike(content)) return false;

    const editorState = EditorState.createWithContent(convertFromRaw(content));
    return editorState.getCurrentInlineStyle().includes(inlineStyle);
};
